import { getValidAccessToken } from "../../../Services/oauthService";
import { apiFetch } from "../../../utils/apiClient";

export const selectedCoverPlanMedical = (data) => {
    
  return async (dispatch) => {
  const token = await getValidAccessToken();
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/medical/leads`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`},
      });
      return val;
    } catch (error) {
      console.error('Error in getAffrodablePlans:', error);
      throw error;
    }
  };
};

export const updateLeadsMedical = (data) => {
    
  return async (dispatch) => {
  const token = await getValidAccessToken();
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/medical/leads`, {
        method: 'PUT',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json',Authorization: `Bearer ${token}`},
      });
      return val;
    } catch (error) {
      console.error('Error in updateLeadsMedical:', error);
      throw error;
    }
  };
};

export const getLeadsDataByMobileOrCivilId = (data) => {
    
  return async (dispatch) => {
  const token = await getValidAccessToken();
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/medical/search/mobileOrCivilId`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`},
      });
      return val;
    } catch (error) {
      console.error('Error in getAffrodablePlans:', error);
      throw error;
    }
  };
};
